export default __webpack_public_path__ + "static/cordo.icon.services-b9f31a6e8331cfb4041cd2ee00b7dde5.svg";